import React from 'react'
import Modal from 'react-modal'

const base = 'nm-modal'
const afterOpen = 'after-open'
const beforeClose = 'before-close'
const contentBase = `${base}__content`
const overlayBase = `${base}__overlay`

const styleGenerator = baseClass => ({
  base: baseClass,
  afterOpen: `${baseClass}--${afterOpen}`,
  beforeClose: `${baseClass}--${beforeClose}`,
})

export const MmModal = ({ isOpen, close, contentLabel, children }) =>
  <Modal
    isOpen={isOpen}
    onRequestClose={close}
    contentLabel={contentLabel}
    className={styleGenerator(contentBase)}
    overlayClassName={styleGenerator(overlayBase)}
  >
    <button className={`${base}__close`} onClick={close}>X</button>
    {children}
  </Modal>



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/shared_components/modal/Modal.view.js